<template>
  <LayoutGridComponent
    :class="$style.root"
    v-if="links?.length"
  >
    <CoreBlocksExternalLinksItemComponent
      :class="$style.root"
      v-for="item in links"
      :item="item"
    />
  </LayoutGridComponent>
</template>

<script setup>
const props = defineProps({
  block: Object
})

const links = computed(() => {
  return props?.block?.external_links?.filter(i => i?.descriptions?.current_locale || i?.labels?.current_locale)
})
</script>

<style module>
.root {
  padding-top: var(--unit--vertical--double);
}

.item {
  padding-left: var(--unit--horizontal--tripple);
  padding-right: var(--unit--horizontal--tripple);

  display: flex;
  flex-direction: column;
  flex-wrap: wrap;

  text-align: center;
}
</style>
